import { removeIE } from '../../tools/helpers';
import initModules from '../initModules';

// Polyfill
removeIE();

/* eslint-disable no-underscore-dangle  */
export default class BfvRepeatableList {
  hasMoreThanOne = false;
  enumChildren = 0;

  constructor(props = {}) {
    this.$root = props.element;
    this.$itemList = this.$root.querySelector('.js-repeatable-itemList');
    this.$items = this.$root.querySelectorAll('.js-repeatable-item');
    this.$addButton = this.$root.querySelector('.js-repeatable-button-add');
    this.$addButtonWrapper = this.$root.querySelector('.js-repeatable-button-add-wrapper');

    this.maxLength = this.$root.getAttribute('data-limit');

    /* fn() bindings */
    this.__addItem = this.__addItem.bind(this);
    this.__deleteItem = this.__deleteItem.bind(this);
    this.__filterClicks = this.__filterClicks.bind(this);
  }

  // <editor-fold defaultstate="collapsed" desc="*** Helpers ***">
  /**
   * clears values of input elements
   * @param parentNode
   * @private
   */
  static __clearItem(node) {
    const inputList = [...node.querySelectorAll('input')];
    const selectList = [...node.querySelectorAll('select')];
    const lazyloadWrapper = node.querySelector('.js-filtered-lazyload-content-wrapper');

    if (lazyloadWrapper) {
      lazyloadWrapper.innerHTML = '';
    }

    inputList.forEach((input) => {
      input.value = ''; // eslint-disable-line no-param-reassign
    });

    selectList.forEach((select) => {
      select.selectedIndex = 0; // eslint-disable-line
    });
  }

  /**
   * init class
   */
  init() {
    if (!this.$root) {
      return;
    }

    this.__enumChildren();
    this.__bindEvents();
  }

  /**
   * check how many items we have
   * @returns {number}
   * @private
   */
  __enumChildren() {
    this.$items = this.$root.querySelectorAll('.js-repeatable-item');

    if (!this.$items.length) {
      throw new Error('BfvRepeatableList needs at least one block of items to repeat it!');
    }

    this.enumChildren = this.$items.length;
    this.hasMoreThanOne = this.$items.length > 1;

    this.$items.forEach((item, index) => {
      const count = index + 1;
      const $enumDisplay = item.querySelector('.js-achievement-number');
      const $inputs = Array.concat([...item.querySelectorAll('input')], [...item.querySelectorAll('select')]);
      $inputs.forEach((element) => {
        const name = element.getAttribute('name');
        element.setAttribute('name', name.replace(/\d+/g, count));
        element.setAttribute('id', name.replace(/\d+/g, count));

        if (element.getAttribute('type') !== 'hidden') {
          element.parentNode.getElementsByTagName('label')[0].setAttribute('for', name.replace(/\d+/g, count));
        }
      });
      $enumDisplay.innerText = count;
    });

    return this.$items.length;
  }

  /**
   * delete complete Block
   * @param buttonNode
   * @private
   */
  __deleteItem(buttonNode) {
    const parentNode = buttonNode.closest('.js-repeatable-item');

    if (this.enumChildren === 1) {
      this.constructor.__clearItem(parentNode);
      initModules({ rootElement: this.$root });
      return;
    }

    parentNode.remove();
    this.$addButtonWrapper.classList.remove('input', 'input--error');
    this.__enumChildren();
  }

  /**
   * add Block
   * @private
   */
  __addItem() {
    if (this.maxLength && this.$items.length >= this.maxLength) {
      this.$addButtonWrapper.classList.add('input', 'input--error');
    } else {
      const itemSkeleton = this.$items[0].cloneNode(true);
      const errorElements = itemSkeleton.querySelectorAll('.input--error');

      if (errorElements) {
        errorElements.forEach((error) => {
          error.classList.remove('input--error');
        });
      }

      this.constructor.__clearItem(itemSkeleton);
      this.$itemList.appendChild(itemSkeleton);

      initModules({ rootElement: this.$root });
      this.__enumChildren();
    }
  }

  /**
   * filter EventListener
   * @param ev
   * @returns {*}
   * @private
   */
  __filterClicks(ev) {
    if (ev.target.closest('button.js-repeatable-item__delete')) {
      ev.stopPropagation();
      return this.__deleteItem(ev.target.closest('button.js-repeatable-item__delete'));
    }
    return ev;
  }


  /**
   * bind events bundled to one function
   * @private
   */
  __bindEvents() {
    this.$itemList.addEventListener('click', (ev) => {
      this.__filterClicks(ev);
    });
    this.$addButton.addEventListener('click', (ev) => {
      this.__addItem(ev);
    });
  }

  // </editor-fold>
}



// WEBPACK FOOTER //
// ./src/javascript/main/BfvRepeatableList/index.js